/**
 * Isopure custom cursor — smooth follow + hover + scroll states
 */
(function () {
  if (!window.matchMedia('(pointer: fine)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var cursor = document.getElementById('iso-cursor');
  if (!cursor) return;

  document.documentElement.classList.add('iso-cursor-enabled');

  var dot = cursor.querySelector('.iso-cursor__dot');
  var ring = cursor.querySelector('.iso-cursor__ring');
  var pos = { x: -100, y: -100 };
  var ringPos = { x: -100, y: -100 };
  var scrollTimer = null;
  var HOVER_SELECTOR =
    'a, button, input, textarea, select, label, summary, [role="button"], .collection-card, .media-grid__item, .zoom-image--enabled .group';

  function lerp(start, end, amount) {
    return start + (end - start) * amount;
  }

  function setPosition(el, x, y) {
    el.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0) translate(-50%,-50%)';
  }

  function isInteractiveTarget(target) {
    if (!target || !target.closest) return false;
    if (target.closest('.product-gallery, custom-cursor, .navigation-drawer')) return false;
    return !!target.closest(HOVER_SELECTOR);
  }

  function markScrolling() {
    cursor.classList.add('is-scrolling');
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function () {
      cursor.classList.remove('is-scrolling');
    }, 140);
  }

  function onPointerMove(event) {
    pos.x = event.clientX;
    pos.y = event.clientY;
    cursor.classList.add('is-visible');
    cursor.classList.toggle('is-hover', isInteractiveTarget(event.target));
    setPosition(dot, pos.x, pos.y);
  }

  function onPointerLeave() {
    cursor.classList.remove('is-visible', 'is-hover');
  }

  window.addEventListener('pointermove', onPointerMove, { passive: true });
  document.documentElement.addEventListener('pointerleave', onPointerLeave);
  window.addEventListener('scroll', markScrolling, { passive: true });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) cursor.classList.remove('is-visible');
  });

  function animate() {
    ringPos.x = lerp(ringPos.x, pos.x, 0.14);
    ringPos.y = lerp(ringPos.y, pos.y, 0.14);
    setPosition(ring, ringPos.x, ringPos.y);
    requestAnimationFrame(animate);
  }

  animate();
})();
